import { MenuItem, Select, SelectProps } from "@material-ui/core";

const deliveryTimeSlots = Object.freeze([
  "14:00-18:00",
  "19:00-22:00",
  "20:00-23:00",
  "22:00-23:00",
]);

const pickupTimeSlots = Object.freeze([
  "09:00-13:00",
  "14:00-18:00",
  "20:00-23:00",
]);

export interface HoursTimeRangesPickerProps
  extends Partial<Omit<SelectProps, "onChange" | "value" | "multiple">> {
  value: string[];
  optionsType: "delivery" | "pickup";
  onChange: (v: string[]) => void;
}

export function HoursTimeRangesPicker(props: HoursTimeRangesPickerProps) {
  const { value, optionsType, onChange, ...selectProps } = props;

  const handleChangeMultiple = (evt) => {
    onChange(evt.target.value);
  };

  return (
    <Select
      {...selectProps}
      multiple
      value={value}
      onChange={handleChangeMultiple}
    >
      {(optionsType === "delivery" ? deliveryTimeSlots : pickupTimeSlots).map(
        (timeRange) => (
          <MenuItem key={timeRange} value={timeRange}>
            {timeRange}
          </MenuItem>
        )
      )}
    </Select>
  );
}
